import { Button, Modal, Space, Typography } from "antd";
import { ShieldAlert } from "lucide-react";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { securityApi } from "../../backend/security";
import { mfaRequiredModalState } from "../../recoil/mfa-required";
import { currentProjectState, projectsState } from "../../recoil/project";
import { signInAgain } from "../../utils/mfa-step-up";

const MfaRequiredModal = () => {
    const [state, setState] = useRecoilState(mfaRequiredModalState);
    const currentProject = useRecoilValue(currentProjectState);
    const projects = useRecoilValue(projectsState);
    const [hasFactors, setHasFactors] = useState<boolean>();

    useEffect(() => {
        if (!state.visible) {
            return;
        }

        // Lazily loaded: the modal still works when the overview is unavailable.
        securityApi.getOverview()
            .then(overview => setHasFactors(overview.authenticationFactors.length > 0))
            .catch(() => setHasFactors(undefined));
    }, [state.visible]);

    const projectName = (state.projectId
        ? projects.find(project => project.id === state.projectId)?.name
        : undefined) || (state.projectId && state.projectId === currentProject?.id ? currentProject?.name : undefined);

    const onCancel = () => {
        setState({ visible: false });
    };

    return (
        <Modal
            title="Two-step verification required"
            centered
            closable={true}
            open={state.visible}
            onCancel={onCancel}
            zIndex={1001}   // always display on top (default is 1000)
            footer={[
                ...(hasFactors === false ? [
                    <Button key="set-up" href="/account/security">
                        Set up two-step verification
                    </Button>
                ] : []),
                <Button
                    key="sign-in-again"
                    type="primary"
                    onClick={() => signInAgain(`${window.location.pathname}${window.location.search}`)}
                >
                    Sign in again
                </Button>
            ]}
        >
            <Space align="start" size="middle">
                <ShieldAlert size={24} />
                <Typography.Text>
                    {projectName ? `${projectName} requires two-step verification.` : "This project requires two-step verification."}
                    {" "}
                    Sign in again with your authenticator app or passkey to continue.
                </Typography.Text>
            </Space>
        </Modal>
    );
};

export default MfaRequiredModal;
